var map = {
	"./ebook-box-image-01.png": 2701,
	"./ebook-box-image-02.png": 2272,
	"./ebook-box-image-03.png": 9430,
	"./ebook-box-image-04.png": 523,
	"./ebook-box-image-05.png": 7733,
	"./ebook-box-image-06.png": 7170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9875;